module.exports = __webpack_public_path__ + "static/media/search-empty.c1fd5d4c428b60b61685b590b5e2d1e6.svg";